<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<a id="page1"></a>
<p class="title"><img alt="Image" src="images/title.jpg"/></p>
<p class="title2"><b>Sharlene Frances</b><br/>Writing From the Heart</p>
<p class="logo"><img alt="Image" src="images/logo.jpg"/></p>
<p class="publish"><i>8370 Eleusis Drive, Anchorage, Alaska 99502-4630<br/><a href="mailto:books@publicationconsultants.com">books@publicationconsultants.com</a>—<a href="http://www.publicationconsultants.com" target="_blank">www.publicationconsultants.com</a></i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5a667342